import {
    forwardRef,
    InputHTMLAttributes,
    ReactNode,
    useEffect,
    useImperativeHandle,
    useRef,
} from "react";

export default forwardRef(function TextInputWithDatalist(
    {
        type = "text",
        className = "",
        isFocused = false,
        disabled = false,
        containerClassName = "",
        error,
        icon,
        options = [],
        onSelectOption,
        ...props
    }: InputHTMLAttributes<HTMLInputElement> & {
        isFocused?: boolean;
        icon?: ReactNode;
        containerClassName?: string;
        options: string[];
        error?: string;
        onSelectOption?: (option: string) => void;
    },
    ref,
) {
    const localRef = useRef<HTMLInputElement>(null);

    useImperativeHandle(ref, () => ({
        focus: () => localRef.current?.focus(),
    }));

    useEffect(() => {
        if (isFocused) {
            localRef.current?.focus();
        }
    }, [isFocused]);

    const baseClass =
        "rounded-md border-gray-300 shadow-sm focus:border-neutral4 focus:ring-neutral4 ring-neutral4";

    const disabledClass = "opacity-50 cursor-not-allowed";
    const errorClasses = " border border-red-700 ";

    return (
        <div className={`relative inline-flex ${containerClassName}`}>
            <datalist id={`datalist-id-${props.name}`}>
                {options.map((item, index) => {
                    return <option key={index} value={item} />;
                })}
            </datalist>
            {icon && (
                <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                    {icon}
                </div>
            )}

            <input
                {...props}
                type={type}
                list={`datalist-id-${props.name}`}
                disabled={disabled}
                onChange={(e) => {
                    const val = e.target.value;
                    props.onChange?.(e);

                    if (options.includes(val)) {
                        onSelectOption?.(val);
                    }
                }}
                className={
                    "flex-1 " +
                    baseClass +
                    (disabled ? disabledClass : "") +
                    (icon ? " pl-10 " : "") +
                    className +
                    (error !== undefined ? errorClasses : "")
                }
                ref={localRef}
            />
        </div>
    );
});
